import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.grey003};
  border-radius: 33px;
`;

export const Progress = styled.div`
  transition: width 0.3s linear;
  width: ${({ width }) => width}%;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.greenMain};
  border-radius: 33px;
`;
